import { render, staticRenderFns } from "./flexible-section.vue?vue&type=template&id=5e1dbeaf"
import script from "./flexible-section.vue?vue&type=script&lang=js"
export * from "./flexible-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports